export class UnauthorizedError extends Error {
  constructor(_response: Response) {
    super("Request failed with HTTP status 401 Unauthorized")
  }
}
